/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { FC, Fragment, memo, useEffect } from "react";
import { createUseStyles } from "react-jss";
import { areEqualShallow } from "Utils/areEqual";
import { motion } from "framer-motion";
import { AccordionItem } from "Components/Accordion";
import styles from "./styles";
import PointList from "./PointList";

interface Props {
  suggestions: Array<object>;
  selectedTrail: string;
  trailButtonClick: (suggestion: any, identifier: string, idx: number) => void;
  showTrails: boolean;
}

const TrailsList: FC<Props> = memo(
  ({
    suggestions,
    selectedTrail,
    trailButtonClick,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    showTrails = true,
  }: Props) => {
    const useStyles = createUseStyles(styles);
    const classes = useStyles();

    const trailsSortedByOrder = suggestions.sort(
      (a: any, b: any) => a.order - b.order
    );

    const handleTrailClick = (suggestion: any, name: any, idx: number) => {
      if (trailButtonClick) {
        trailButtonClick(suggestion, name, idx);
      }
    };

    useEffect(() => {
      const handleKeyDown = (event: KeyboardEvent) => {
        const closeButton = document.getElementById("close-button");
        const lastItem = suggestions[suggestions.length - 1] as any;
        if (
          event.key === "Tab" &&
          document.activeElement.id.includes(
            `${lastItem?.name}-${suggestions.length - 1}`
          ) &&
          closeButton
        ) {
          event.preventDefault();
          closeButton.focus();
        }
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    }, [suggestions]);

    return (
      <div id="trailslist" className={classes.container}>
        <div id="trailsCount" tabIndex={0} className={classes.trailCount}>
          {trailsSortedByOrder.length} Trails
        </div>
        {trailsSortedByOrder.map((suggestion: any, idx: number) => {
          const { Stops, name } = suggestion;
          const stopsLength = Stops?.length;
          const identifier = `${name}-${idx.toString()}`;

          return stopsLength > 0 ? (
            <Fragment key={identifier}>
              <AccordionItem
                id={identifier}
                onClick={() => handleTrailClick(suggestion, name, idx)}
                title={name}
                selectedTrail={selectedTrail}
                expanded={selectedTrail === name}
                itemCount={stopsLength}
              >
                {selectedTrail === name && (
                  <motion.div
                    className={`${classes.iconContainer}
                ${
                  idx !== trailsSortedByOrder.length - 1
                    ? classes.flexRowPaddingBottom
                    : ""
                }
                `}
                  >
                    <PointList
                      points={Stops}
                      pointsLength={stopsLength}
                      idx={idx}
                      classes={classes}
                    />
                  </motion.div>
                )}
              </AccordionItem>
            </Fragment>
          ) : null;
        })}
      </div>
    );
  },
  areEqualShallow
);

export default TrailsList;
